// extracted by mini-css-extract-plugin
export default {"title":"Post_title__ik576","details":"Post_details__VScNK","row":"Post_row__8Vl-s","thumbnail":"Post_thumbnail__3Bit2","content":"Post_content__CVWbQ"};